import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=98f840c8&scoped=true"
import script from "./warehouse.vue?vue&type=script&lang=js"
export * from "./warehouse.vue?vue&type=script&lang=js"
import style0 from "./warehouse.vue?vue&type=style&index=0&id=98f840c8&prod&style=true&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f840c8",
  null
  
)

export default component.exports